import { createFeatureLayers } from "../createFeatureLayers";

const useMapInitializer = () => {
  const addProxyRule = (urlUtils) => {
    urlUtils.addProxyRule({
      urlPrefix: "https://esri.qservco.com/server",
      proxyUrl: process.env.REACT_APP_PROXY_URL,
    });
  };

  const addESRIWidgets = ({
    Basemap,
    BasemapGallery,
    Compass,
    Expand,
    featureLayers,
    Graphic,
    LayerList,
    Legend,
    Locate,
    ScaleBar,
    Search,
    Track,
    view,
  }) => {
    addBasemapGalleryWidget({
      BasemapGallery: BasemapGallery,
      view: view,
      Expand: Expand,
      Basemap: Basemap,
    });
    addCompassWidget({
      Compass: Compass,
      view: view,
    });
    addLegendWidget({ Legend: Legend, view: view, Expand: Expand });
    addLayerListWidget({
      LayerList: LayerList,
      view: view,
      Expand: Expand,
    });
    addLocateWidget({
      Locate: Locate,
      view: view,
      Graphic: Graphic,
    });
    addSearchWidget({
      Search: Search,
      view: view,
      featureLayers: featureLayers,
    });
    addTrackWidget({
      Track: Track,
      view: view,
    });
    addScaleBarWidget({
      view: view,
      ScaleBar: ScaleBar,
    });
  };

  const addLegendWidget = ({ Legend, view, Expand }) => {
    const legend = new Expand({
      content: new Legend({
        view: view,
      }),
      view,
      expandIconClass: "esri-icon-legend",
      collapseIconClass: "esri-icon-collapse",
    });

    view.ui.add(legend, { position: "top-right", index: 1 });
  };

  const addLayerListWidget = ({ LayerList, view, Expand }) => {
    const layerList = new LayerList({
      view: view,
    });
    const legend = new Expand({
      content: layerList,
      view,
      expandIconClass: "esri-icon-layer-list",
      collapseIconClass: "esri-icon-collapse",
    });

    view.ui.add(legend, { position: "top-right", index: 2 });
  };

  const addBasemapGalleryWidget = ({
    BasemapGallery,
    view,
    Expand,
    Basemap,
  }) => {
    const basemapGallery = new Expand({
      content: new BasemapGallery({
        view: view,
        source: [
          Basemap.fromId("dark-gray-vector"),
          Basemap.fromId("gray-vector"),
          Basemap.fromId("hybrid"),
          Basemap.fromId("oceans"),
          Basemap.fromId("osm"),
          Basemap.fromId("satellite"),
          Basemap.fromId("streets-navigation-vector"),
          Basemap.fromId("streets-night-vector"),
          Basemap.fromId("streets-relief-vector"),
          Basemap.fromId("streets-vector"),
          Basemap.fromId("terrain"),
          Basemap.fromId("topo-vector"),
        ],
      }),
      view,
      expandIconClass: "esri-icon-basemap",
      collapseIconClass: "esri-icon-collapse",
    });

    // Add widget to the top right corner of the view
    view.ui.add(basemapGallery, {
      position: "top-left",
      index: 2,
    });
  };

  const addCompassWidget = ({ Compass, view }) => {
    let compass = new Compass({
      view: view,
    });

    // adds the compass to the top left corner of the MapView
    view.ui.add(compass, "top-left");
  };

  const addLocateWidget = ({ Locate, view, Graphic }) => {
    let locateWidget = new Locate({
      view: view,
    });

    view.ui.add(locateWidget, "top-right");
  };

  const addTrackWidget = ({ Track, view }) => {
    let track = new Track({
      view: view,
    });
    view.ui.add(track, "top-right");
  };

  const addScaleBarWidget = ({ view, ScaleBar }) => {
    let scaleBar = new ScaleBar({ view: view });
    view.ui.add(scaleBar, "bottom-left");
  };

  const addSearchWidget = ({ Search, view, featureLayers }) => {
    const maxSuggestions = 4;
    const searchWidget = new Search({
      view: view,
      allPlaceholder: "Search...",
      sources: [
        {
          name: "LCP Boundaries",
          layer: featureLayers.lcpLayer,
          searchFields: ["AREANAME", "AREAID", "NAME"],
          maxSuggestions: maxSuggestions,
          //placeholder: "Enter LCP",
        },
        // {
        //   name: "Splice Closures",
        //   layer: featureLayers.spliceClosureLayer,
        //   searchFields: ["STRUCTURE_NAME"],
        //   maxSuggestions: maxSuggestions,
        //   //placeholder: "Splice Closure identifier",
        // },
        // {
        //   name: "Poles",
        //   layer: featureLayers.polesLayer,
        //   searchFields: ["STRUCTURE_NAME"],
        //   maxSuggestions: maxSuggestions,
        //   //placeholder: "Splice Closure identifier",
        // },
        // {
        //   name: "Structures",
        //   layer: featureLayers.structureLayer,
        //   searchFields: ["STRUCTURE_NAME"],
        //   maxSuggestions: maxSuggestions,
        //   //placeholder: "Splice Closure identifier",
        // },
      ],
    });
    view.ui.add(searchWidget, {
      position: "top-left",
      index: 0,
    });
  };

  return {
    addProxyRule,
    addESRIWidgets,
    createFeatureLayers,
  };
};

export default useMapInitializer;
